<template>
  <section>
    <h1 class="text-h3 mb-8">
      Chips
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <div
        v-for="(style, i) in styles"
        :key="i"
        :class="{ 'pb-4': i < styles.length - 1 }"
      >
        <v-chip
          v-bind="style"
        >
          {{ style.label ? 'Label' : 'Pill' }} chip
        </v-chip>
        <v-chip
          v-bind="style"
        >
          <v-icon
            :small="style.small"
            left
          >
            fa-solid fa-circle-info
          </v-icon>
          {{ style.label ? 'Label' : 'Pill' }} chip
        </v-chip>
        <v-chip
          v-bind="style"
          close
        >
          {{ style.label ? 'Label' : 'Pill' }} chip
        </v-chip>
        <v-chip
          v-bind="style"
          close
        >
          <v-icon
            :small="style.small"
            left
          >
            fa-solid fa-circle-info
          </v-icon>
          {{ style.label ? 'Label' : 'Pill' }} chip
        </v-chip>
        <v-divider
          v-if="i < styles.length - 1"
          class="mt-4"
        />
      </div>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/chips/">
      <strong>Chips</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'ComponentsChips',
  data: () => ({
    styles: [
      {},
      {
        label: true
      },
      {
        color: 'primary'
      },
      {
        color: 'primary',
        label: true
      },
      {
        color: 'primary',
        small: true
      }
    ]
  })
}
</script>

<style lang="scss" scoped>
.v-chip {

  + .v-chip {
    margin-left: 8px;
  }
}
</style>
